import { ICampaign } from '@/galaxy-cruise/api_interface'
import { asyncAlert } from '@/galaxy-cruise/components/AsyncAlert'
import { store } from '@/store'
import { time } from '@/utils/time'
import { Component, Vue, Watch } from 'vue-property-decorator'
import Campaign from './campaign.vue'
import CampaignBeginOrEnd from './CampaignBeginOrEnd.vue'

@Component({
  components: { Campaign },
})
export default class extends Vue {
  get gc() {
    return store.galaxyCruise
  }

  get campaigns() {
    return this.gc.session!.campaigns
  }

  get activeCampaigns() {
    const now = this.gc.now
    return this.campaigns.filter(c => c.period_begin <= now && now < c.period_end)
  }

  get activeCampaignsJson() {
    return JSON.stringify(this.activeCampaigns)
  }

  @Watch('activeCampaignsJson')
  async onActiveCampaignsChange(afterJson: string, beforeJson: string) {
    await time.sleep(1000)
    const after: ICampaign[] = JSON.parse(afterJson)
    const before: ICampaign[] = JSON.parse(beforeJson)
    if (before.length == 0 && after.length == 1) {
      await asyncAlert({ component: CampaignBeginOrEnd, closable: false, props: { campaign: after[0], begin: true } })
    }
    if (before.length == 1 && after.length == 0) {
      await asyncAlert({ component: CampaignBeginOrEnd, closable: false, props: { campaign: before[0], begin: false } })
    }
  }
}
